import { settings_ttl } from "@core/helpers/server/cache-data/settings-ttl";
import cache, { dev_mode_cache_prefix } from "@core/helpers/server/cache";
import { get_web_project_settings_query } from "@core/services/web-project";
import supported_locales from "@core/constants/supported-locales.json";

const detect_locate = (all_locales = [], pathname) => {
	const all_locales_count = all_locales?.length;
	const default_locale = all_locales?.[0] ;
	const more_locales = all_locales_count > 1 ? [...all_locales?.slice(1)] : [];

	let current_locale = more_locales?.find((locale) => pathname?.startsWith(`/${locale}/`) || pathname === `/${locale}`);

	let invalid_locale = false;

	if (!current_locale) {
		const [first_slug] = pathname?.replace("/", "")?.split("/");
		const first_slug_is_locate = supported_locales?.includes(first_slug);

		if (first_slug_is_locate) {
			invalid_locale = true;
		}

		current_locale = default_locale;
	}

	return { current_locale, invalid_locale, all_locales };
}

const getSiteDetails = async (pathname) => {
	const data = await get_web_project_settings_query({ keys: ["google_tag_manager_id", "logo_site"] });

	const _all_locales = data?.data?.getWebProjectSettings?.lang?.all_langs || ["fa"];

	const { current_locale, invalid_locale, all_locales } = detect_locate(_all_locales, pathname);

	const site_status = data?.data?.getWebProjectSettings?.update_status || 1;

	let web_scripts = data?.data?.webScripts || [];
	let gtm_id = data?.data?.settings?.find(item => item?.key === "google_tag_manager_id")?.value || '';

	let config_keys = data?.data?.config_keys || [];

	const web_currency = data?.data?.getWebProjectSettings?.currency || 1;

	const web_storage_prefix_url = data?.data?.getWebProjectSettings?.storage_prefix_url;

	const route_names = data?.data?.route_names || {};

	let logo_site = data?.data?.settings?.find(item => item?.key === "logo_site")?.value || '';

	return {
		all_locales,
		invalid_locale,
		current_locale,

		site_status,
		web_scripts,
		gtm_id,
		web_currency,
		web_storage_prefix_url,
		route_names,
		logo_site,
		config_keys,
		// the request failed or came back without the settings: kept only a few seconds (`settings_ttl`)
		read_failed: !data?.status || !data?.data?.getWebProjectSettings,
	};
};

const cache_key = "site-settings";
const siteSetting = async (pathname, force = true) => {
	if (!pathname) {
		const { headers } = require("next/headers");
		const headers_list = await headers();

		if (!headers_list.get('x-pathname')) {
			return {}
		} else {
			pathname = headers_list.get('x-pathname') || "/";
		}
	}

	// storefront dev mode: a browser in dev mode reads another site's settings (dev-mode-rules.js)
	const key = (await dev_mode_cache_prefix()) + cache_key;
	let siteDetail = cache.get(key);
	if (!siteDetail && pathname && force) {
		// getOrSet (all sites): concurrent misses share one request; it was one request per caller (~30 on a cold start).
		// getOrSet adds the dev-mode prefix itself, so it gets the bare key (stored under the same `key` as before).
		let fetched_here = false;
		siteDetail = await cache.getOrSet(cache_key, settings_ttl, () => {
			fetched_here = true;
			return getSiteDetails(pathname);
		});
		// a caller that waited on another request's fetch still gets the locale of its own pathname
		if (!fetched_here) {
			siteDetail = { ...siteDetail, ...detect_locate(siteDetail?.all_locales, pathname) };
		}
	} else {
		siteDetail = {
			...siteDetail,
			...detect_locate(siteDetail?.all_locales, pathname)
		};
	}
	return siteDetail;
}

export default siteSetting;
